import { Badge, styled } from '@mui/material';

/* CSS Style. */
export const customized_style = {
    itemPaper: {
        borderRadius: 5,
        m: 2,
        p: 3,
        minHeight: 780,
        height: '90.5vh',
        boxShadow: '0px 1px 1px 1px rgba(0, 0, 0, 0.1)',
    },
    itemMenu: {
        color: '#003a52',
        fontSize: '0.9rem',
        fontWeight: 'medium',
        ':hover': {
            textDecoration: 'underline',
            fontWeight: 'bold',
        },
    },
    itemSubMenu: {
        fontSize: '0.9rem',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
};
